/**
 * 检测第三方账号是否已经绑定过
 */
import PbAjax from '../../../lib/pbajax';
import url from 'c-url';
import publicpb from '../../../base/public.pb';
import EmailVerifyCheckPb from './emailregisterverifycheck.pb';

let pbajax = new PbAjax();

class EmailVerifyCheck {

    constructor(data = {}) {
        this.promise = this.emailCheck(data);
    }

    emailCheck(data) {
        let defer = $.Deferred();
        const { Request, Response } = EmailVerifyCheckPb.Email.RegisterVerifyCheck;

        let businessData = new Request(data); //emailCheckCode
        
        let requestData = {
            service: 'service',
            api: '/email/register/verify/check'
        }

        pbajax.do(
            requestData,
            businessData,
            function(res) {
                let dataWrap = publicpb.Result.decode(res);
                
                if (dataWrap.code == 1) {
                    defer.resolve(true);
                } else {
                    defer.reject(dataWrap);
                }
            },
            () => {
                defer.reject();
            },
            () => {
                defer.reject();
            });
        return defer.promise();
    }
}

export default EmailVerifyCheck;


// WEBPACK FOOTER //
// ./js/component/email-login/findpwd/emailverifycheck.js